module.exports = __webpack_public_path__ + "static/img/heart.a6b2e518.gif";